import { useEffect } from "react";

type ClutchWindow = Window & {
  CLUTCHCO?: {
    Init?: () => void;
  };
};

const CLUTCH_SCRIPT_ID = "clutch-widget-script";
const CLUTCH_SCRIPT_SRC = "https://widget.clutch.co/static/js/widget.js";

export function ClutchWidget() {
  useEffect(() => {
    const init = () => {
      (window as ClutchWindow).CLUTCHCO?.Init?.();
    };

    const existing = document.getElementById(CLUTCH_SCRIPT_ID) as HTMLScriptElement | null;

    if (existing) {
      init();
      existing.addEventListener("load", init, { once: true });
      return () => existing.removeEventListener("load", init);
    }

    const script = document.createElement("script");
    script.id = CLUTCH_SCRIPT_ID;
    script.src = CLUTCH_SCRIPT_SRC;
    script.async = true;
    script.addEventListener("load", init, { once: true });
    document.body.appendChild(script);

    return () => script.removeEventListener("load", init);
  }, []);

  return (
    <div
      className="clutch-widget"
      data-url="https://widget.clutch.co"
      data-widget-type="14"
      data-height="50"
      data-nofollow="false"
      data-expandifr="true"
      data-scale="100"
      data-clutchcompany-id="604668"
    />
  );
}
